/* Testimonial videos: autoplay muted and silent.

   Idle    -> full-card play overlay ("Ver con sonido").
   Playing -> overlay gone, small pause button bottom-left.

   Deliberately no native <video controls>: the control bar is a few pixels
   tall inside a narrow card, and a click on it also lands on the video. */
(function () {
  if (window.alchemyVideoPlayReady) return;
  window.alchemyVideoPlayReady = true;

  function stop(card) {
    const video = card.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.loop = true;
    card.classList.remove('is-playing');
    video.play().catch(() => {});
  }

  function play(card) {
    const video = card.querySelector('video');
    if (!video) return;

    const root = card.closest('[data-alchemy-carousel-root]');
    if (root) {
      root.querySelectorAll('.alchemy-vt__card.is-playing').forEach((other) => {
        if (other !== card) stop(other);
      });
      const track = root.querySelector('[data-alchemy-carousel]');
      if (track && track.alchemyCarousel) track.alchemyCarousel.stop();
    }

    video.muted = false;
    video.loop = false;
    card.classList.add('is-playing');

    video.play().catch(() => {
      // Some browsers refuse to start audio without a more direct gesture.
      // Fall back to the muted preview rather than leaving a frozen frame.
      stop(card);
    });

    video.addEventListener('ended', () => stop(card), { once: true });
  }

  function bind(scope, selector, handler) {
    (scope || document).querySelectorAll(selector).forEach((btn) => {
      if (btn.dataset.alchemyReady === 'true') return;
      btn.dataset.alchemyReady = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const card = btn.closest('.alchemy-vt__card');
        if (card) handler(card);
      });
    });
  }

  function init(scope) {
    bind(scope, '[data-alchemy-play]', play);
    bind(scope, '[data-alchemy-pause]', stop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
